import { MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import ScrollTo from "react-scroll-into-view";
import ImageBlock from './ImageBlock';
import { motion } from "framer-motion";


const SectionTwo = ({sectionId, sectionSelector, sectionImage}) => {


  return (
    <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center">
        <MDBCol className="col-sm-12 col-md-6 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 section-bg-yellow p-5">
            <span className="text-black">IPSUM NULLAM</span>
            <motion.div initial={{ opacity: 0, x:-200 }} whileInView={{  opacity: 1, x:0 }}  transition={{ delay: 0.25 }} >
                <h2 className="display-2 my-4 section-font"><strong>SED ALIQUAM</strong></h2>
            </motion.div>
            <h4 className="text-black">Neque laoreet suspendisse interdum consectetur libero. Lorem dolor at viverra ipsum nunc aliquet. Faucibus placerat vestibulum. Risus letanie feugiat posuere.</h4>
            <ScrollTo selector={sectionSelector}>
                <MDBIcon fas icon="arrow-circle-down" size='4x' className="section-icon my-3" />
            </ScrollTo>
        </MDBCol>
        <ImageBlock myImage={sectionImage} />
      </MDBRow>
  )
}

export default SectionTwo
